import LoanForm from "./pages/LoanForm/LoanForm";
import HomePage from "./pages/HomePage/HomePage";
import RedirectHandler from "./pages/RedirectHandlerPage/RedirectHandlerPage";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { routes } from "./routes";
import { LinkContextProvider } from "./context/LinkContext";

const App = () => {
  return (
    <LinkContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path={routes.home} element={<HomePage />} />
          <Route path={routes.loanForm(":userId")} element={<LoanForm />} />
          <Route path={routes.redirect} element={<RedirectHandler />} />
          <Route path="*" element={<Navigate replace to={routes.home} />} />
        </Routes>
      </BrowserRouter>
    </LinkContextProvider>
  );
};

export default App;
